import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './forget-password.vue'
import newHeader from 'src/views/components/new-header'
import { Store as UserStore } from 'store/modules/user'
import 'common/gt.js'

@Component({
    name: 'forgetPassword',
    mixins: [template],
    components: {
        newHeader
    }
})

export default class ForgetPassword extends Vue {
    @UserStore.action('setUserInfo') setUserInfo
    @UserStore.action('setRedirectUrl') setRedirectUrl
    formName = 'form'
    form = {
        username: '',
        verifyCode: ''
    }
    disabled = false
    originVerifyCode = null
    verifyImage = ''
    errorText = ''
    rules = {
        username: [
            { required: true, message: '请输入您要找回的账号用户名', trigger: 'blur' }
        ],
        validVerifyCode: (rule, value, callback) => {
            if (this.utils.isEmpty(value)) {
                return callback(new Error('请输入验证码'))
            }
            if (!this.utils.isEmpty(rule.code)) {
                if (rule.code !== value) {
                    return callback(new Error('验证码不正确'))
                }
            }
            callback()
        },
        validateUserName: (rule, value, callback) => {
            if (this.utils.isEmpty(value)) {
                return callback(new Error('请输入您要找回的账号用户名'))
            }
            callback()
        }
    }

    created() {
        const redirectUrl = this.$route.query.redirect_url
        this.setRedirectUrl(redirectUrl)
    }

    getVerifyCode() {
        this.api.userApi.getVerifyCode().then((data) => {
            this.form.userIdGt = data.userIdGt  // 设置待传入的 userIdGt
            this.initGeetest(data)  // 初始化验证控件
        })
    }

    /**
     * 初始化极验插件
     */

    initGeetest(data) {
        window.initGeetest({
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.offline,
            new_captcha: true,
            https: true,
            product: 'float',
            width: '100%'
        }, (captchaObj) => {
            captchaObj.appendTo('#captchaBox')
            captchaObj.onReady(() => {
                this.isShowLoading = false
            }).onSuccess(() => {
                this.disabled = false
                this.errorText = ''
                let result = captchaObj.getValidate()
                Object.assign(this.form, result)
            }).onError(() => {

            })
        })
    }

    async handleSubmit() {
        if (!await this.validate(this.formName)) return
        const params = {
            username: this.form.username
        }
        this.api.userApi.checkUsername(params).then((data) => {
            if (data.code !== 200) {
                return this.$message({
                    message: data.message,
                    type: 'warning'
                })
            }
            this.setUserInfo(data.result)
            this.goTo('/user/verify-identity')
        }).catch((error) => {
            let _error = JSON.parse(error.message)
            this.errorText = _error.message
            this.disabled = true
        })
        // this.api.userApi.findPwdNextStep(params).then((data) => {
        //     if (data) {
        //         this.storage.set('setting_from', 'password')
        //         this.setUserInfo(data)
        //         this.goTo('/user/verify-identity')
        //     }
        // }).catch((error) => {
        //     let _error = JSON.parse(error.message)
        //     if (_error.code === '-110118') {
        //         this.errorText = _error.message
        //         this.disabled = true
        //     }
        // })
    }
}



// WEBPACK FOOTER //
// ./src/views/page/main/forget-password/index.js